import React from 'react';
import { Calendar, ArrowRight, Tag } from 'lucide-react';

export const Blog: React.FC = () => {
    const posts = [
        {
            title: "Weak Erections",
            excerpt: "A Weak Erection (also know as impotence or erectile dysfunction) is not a disease, but a secondary condition brought on by other, primary causes...",
            date: "Feb 8, 2026",
            category: "Sexual Health",
            image: "https://09da45aa8861e9e09f066d7bf0bbd9f0.cdn.bubble.io/cdn-cgi/image/w=1024,h=,f=auto,dpr=1,fit=cover,q=75/f1770560477450x765331383660605000/pexels-alex-green-5700186-1024x683-1.jpg",
            link: "https://app.menshealthclinic.africa/insight/weak-erections"
        },
        {
            title: "Penis Prosperity Plan",
            excerpt: "Mens Clinic International developed the penis prosperity plan. This plan is a lifestyle adaptation programme. It addresses many of the causative...",
            date: "Feb 8, 2026",
            category: "Sexual Health",
            image: "https://09da45aa8861e9e09f066d7bf0bbd9f0.cdn.bubble.io/cdn-cgi/image/w=1024,h=,f=auto,dpr=1,fit=cover,q=75/f1770562271243x896582324082146400/Uvelichenie-chuvstvitelnosti-chlena.jpg",
            link: "https://app.menshealthclinic.africa/insight/penis-prosperity-plan"
        },
        {
            title: "Impotence - Myths & Facts",
            excerpt: "There are a lot of misconceptions about impotence or erection problems and their treatment. We’ll give you some of the myths and facts on the...",
            date: "Feb 8, 2026",
            category: "Sexual Health",
            image: "https://09da45aa8861e9e09f066d7bf0bbd9f0.cdn.bubble.io/cdn-cgi/image/w=1024,h=,f=auto,dpr=1,fit=cover,q=75/f1770564262201x718229696938437200/06-Blog-Prostate-Cancer-Treatment-L.jpg",
            link: "https://app.menshealthclinic.africa/insight/-impotence---myths--facts"
        }
    ];

  return (
    <section id="blog" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
            <div className="max-w-2xl">
                <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4">
                    Stay Informed, <br/> <span className="text-primary">Stay Healthy</span>
                </h2>
                <p className="text-gray-600 text-lg">Expert advice and the latest health insights.</p>
            </div>
            <a href="https://app.menshealthclinic.africa/insights" className="text-primary font-bold hover:underline flex items-center gap-2">View all articles <ArrowRight size={18}/></a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {posts.map((post, i) => (
                <a key={i} href={post.link} className="group cursor-pointer flex flex-col h-full block">
                    <div className="rounded-[1.5rem] overflow-hidden mb-6 relative aspect-[4/3]">
                        <div className="absolute inset-0 bg-secondary/10 group-hover:bg-transparent transition-colors z-10"></div>
                        <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                        <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-md px-3 py-1 rounded-full text-xs font-bold text-secondary z-20 shadow-sm flex items-center gap-2">
                            <Calendar size={12} className="text-primary" />
                            {post.date}
                        </div>
                    </div>
                    
                    <div className="flex-1 flex flex-col">
                        <div className="flex items-center gap-2 text-xs text-gray-500 mb-3 font-medium uppercase tracking-wide">
                            <Tag size={12} className="text-primary" />
                            <span>{post.category}</span>
                        </div>

                        <h3 className="text-xl font-bold text-secondary mb-3 group-hover:text-primary transition-colors leading-tight">{post.title}</h3>
                        <p className="text-gray-500 text-sm mb-6 line-clamp-2 leading-relaxed">{post.excerpt}</p>
                        
                        <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between">
                            <span className="text-secondary text-sm font-bold group-hover:text-primary transition-colors">Read Article</span>
                            <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all">
                                <ArrowRight size={14} />
                            </div>
                        </div>
                    </div>
                </a>
            ))}
        </div>
      </div>
    </section>
  );
};